<div class="ui-sidebar-search" *ngIf="!collapsed">
  <mat-icon class="ui-sidebar-search__icon">search</mat-icon>
  <input
    class="ui-sidebar-search__field"
    type="text"
    [placeholder]="placeholder"
    (input)="onInput($event)" />
</div>
